import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = {
  key: 0,
  style: {"font-style":"italic","font-size":"x-small"}
}
const _hoisted_9 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_OpenPoints = _resolveComponent("OpenPoints")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CheckReceivablesAgeing = _resolveComponent("CheckReceivablesAgeing")!
  const _component_OutstandingMatrice = _resolveComponent("OutstandingMatrice")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_SepaAuto = _resolveComponent("SepaAuto")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "pb-2"
      }, {
        default: _withCtx(() => [
          (!!_ctx.sepaAccountableAccount)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    block: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.payDialog = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.sepaTitle), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.otherUserAccessAlowed && _ctx.selectedManager)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    outlined: "",
                    modelValue: _ctx.selectedManager,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedManager) = $event)),
                    items: _ctx.companyUsers,
                    "item-title": _ctx.getUserDisplayName,
                    required: "",
                    "hide-details": "auto",
                    label: "Responsables",
                    "return-object": "",
                    density: "compact"
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                outlined: "",
                modelValue: _ctx.selectedTagIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTagIds) = $event)),
                items: _ctx.thirdPartyCompanyTags,
                "item-value": "id",
                required: "",
                "hide-details": "auto",
                label: "Étiquettes",
                multiple: "",
                density: "compact",
                "item-title": (item) => item.key
              }, null, 8, ["modelValue", "items", "item-title"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                items: _ctx.endMonthlyDates,
                label: "Date de fin",
                elevation: "0",
                outlined: "",
                "hide-details": "",
                density: "compact"
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                outlined: "",
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                "hide-details": "",
                label: "Recherche...",
                type: "text",
                block: "",
                density: "compact",
                "onClick:clear": _cache[5] || (_cache[5] = ($event: any) => (_ctx.search = '')),
                clearable: "",
                "append-inner-icon": "$search"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "1",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TutorialButtonDialog, { starterComponents: 'Outstanding;' })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step) = $event)),
              "fixed-tabs": "",
              style: {"border-radius":"16px","overflow":"hidden"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "0",
                  href: "#0"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("strong", null, "Encours", -1)
                  ])),
                  _: 1
                }),
                (!!_ctx.checkReceivablesAgeingKey)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      value: "1",
                      href: "#1"
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("strong", null, "Échéancier", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'client')
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 1,
                      value: "2",
                      href: "#2"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("strong", null, "Matrice Factures", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OpenPoints, {
                      mode: _ctx.openPointsMode,
                      userId: 
                            _ctx.selectedManager && _ctx.selectedManager.user ? _ctx.selectedManager.user.id : ''
                        ,
                      filteredThirdPartyCompanies: _ctx.filteredThirdPartyCompanies
                    }, null, 8, ["mode", "userId", "filteredThirdPartyCompanies"])
                  ]),
                  _: 1
                }),
                (!!_ctx.checkReceivablesAgeingKey)
                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                      key: 0,
                      value: "1"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.accountingPeriod && _ctx.accountingPeriod.id)
                          ? (_openBlock(), _createBlock(_component_CheckReceivablesAgeing, {
                              key: 0,
                              mode: 'Embedded',
                              companyId: _ctx.companyId,
                              inFilteredThirdPartyCompanies: _ctx.filteredThirdPartyCompanies,
                              accountingPeriodId: _ctx.accountingPeriod.id,
                              acKey: _ctx.checkReceivablesAgeingKey,
                              inSelectedDate: _ctx.receivableAgeingDate,
                              showBarchart: true
                            }, null, 8, ["companyId", "inFilteredThirdPartyCompanies", "accountingPeriodId", "acKey", "inSelectedDate"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.mode === 'client')
                  ? (_openBlock(), _createBlock(_component_v_window_item, {
                      key: 1,
                      value: "2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.startDate)
                          ? (_openBlock(), _createBlock(_component_OutstandingMatrice, {
                              key: 0,
                              companyId: _ctx.companyId,
                              clients: _ctx.filteredThirdPartyCompanies,
                              startDate: _ctx.startDate,
                              endDate: _ctx.outstandingMatriceEndDate
                            }, null, 8, ["companyId", "clients", "startDate", "endDate"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_window_item, { value: "paymentLinks" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "pt-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              "hide-default-header": true,
                              items: _ctx.paymentLinks,
                              "items-per-page": -1,
                              "hide-default-footer": "",
                              density: "compact",
                              class: "table"
                            }, _createSlots({
                              item: _withCtx((props) => [
                                (_openBlock(), _createElementBlock("tr", {
                                  style: {"background-color":"#fff"},
                                  key: props.item.id,
                                  onClick: _withModifiers(($event: any) => (props.item.showDetail = !props.item.showDetail), ["stop"])
                                }, [
                                  _createElementVNode("td", _hoisted_2, [
                                    (1 === 2)
                                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.item.showDetail
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_3, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("strong", null, _toDisplayString(props.item.label), 1)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.formattedDate(props.item.created_at)), 1),
                                  _createElementVNode("td", _hoisted_5, [
                                    _createElementVNode("strong", null, _toDisplayString(props.item.amount
                                                    ? _ctx.newCommonFormatCurrency(props.item.amount)
                                                    : "-"), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_6, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatStatus(props.item.status)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_7, [
                                    (props.item.revoked_at)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString("EXPIRÉ le " +
                                                    _ctx.formattedDate(props.item.revoked_at)), 1))
                                      : _withDirectives((_openBlock(), _createBlock(_component_v_btn_trash, {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.openDeletePaymentLinkDialog(props.item)),
                                          size: "small"
                                        }, null, 8, ["onClick"])), [
                                          [_directive_tooltip, 'Faire expirer ce lien']
                                        ])
                                  ])
                                ], 8, _hoisted_1)),
                                _withDirectives(_createElementVNode("tr", null, _cache[15] || (_cache[15] = [
                                  _createElementVNode("td", {
                                    colspan: "4",
                                    style: {"padding":"0","background":"#f4f4f4"},
                                    class: "py-2 px-0"
                                  }, null, -1)
                                ]), 512), [
                                  [_vShow, props.item.showDetail && 1 === 2]
                                ])
                              ]),
                              _: 2
                            }, [
                              (_ctx.paymentLinks && _ctx.paymentLinks.length > 1)
                                ? {
                                    name: "body.append",
                                    fn: _withCtx(() => [
                                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "text-center" }, null, -1)),
                                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "text-right" }, [
                                        _createElementVNode("strong")
                                      ], -1)),
                                      _createElementVNode("td", _hoisted_9, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.paymentLinks.length) + " liens de paiements générés", 1)
                                        ])
                                      ]),
                                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "text-left" }, null, -1)),
                                      _cache[20] || (_cache[20] = _createElementVNode("td", { class: "text-left" }, null, -1))
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.payDialog)
        ? (_openBlock(), _createBlock(_component_SepaAuto, {
            key: 1,
            modelValue: _ctx.payDialog,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payDialog) = $event)),
            companyId: _ctx.companyId,
            filteredThirdPartyCompanies: _ctx.filteredThirdPartyCompanies,
            accountableAccount: _ctx.sepaAccountableAccount,
            onActionDone: _cache[9] || (_cache[9] = ($event: any) => (_ctx.refresh()))
          }, null, 8, ["modelValue", "companyId", "filteredThirdPartyCompanies", "accountableAccount"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.deletePaymentLinkDialog,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deletePaymentLinkDialog) = $event)),
        title: 'Suppresion du lien de paiement',
        onValid: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deletePaymentLink())),
        validLoading: _ctx.deletePaymentLinkLoading,
        width: "800px"
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createElementVNode("div", { class: "d-flex justify-center" }, " Êtes-vous sûr(e) de vouloir supprimer le lien de paiement ? ", -1),
          _createElementVNode("div", { class: "d-flex justify-center" }, " (le lien deviendra obsolète pour votre client, qui ne pourra plus payer avec) ", -1)
        ])),
        _: 1
      }, 8, ["modelValue", "validLoading"])
    ]),
    _: 1
  }))
}